import { render, staticRenderFns } from "./ShiftUpdateDialog.vue?vue&type=template&id=bb7def0e&"
import script from "./ShiftUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./ShiftUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports